// Genesis Foundation Zero
import { zeroAccordion } from './accordion';
import { zeroAccordionItem } from './accordion-item';
import { zeroActionsMenu } from './actions-menu';
import { zeroAnchor } from './anchor';
import { zeroAnchoredRegion } from './anchored-region';
import { zeroAvatar } from './avatar';
import { zeroBadge } from './badge';
import { zeroBanner } from './banner';
import { zeroBreadcrumb } from './breadcrumb';
import { zeroBreadcrumbItem } from './breadcrumb-item';
import { zeroButton } from './button';
import { zeroCalendar } from './calendar';
import { zeroCard } from './card';
import { zeroCheckbox } from './checkbox';
import { zeroCombobox } from './combobox';
import { zeroConnectionIndicator } from './connection-indicator';
import { zeroDataGrid } from './data-grid';
import { zeroDatePicker } from './date-picker';
import { zeroDesignSystemProvider } from './design-system-provider';
import { zeroDialog } from './dialog';
import { zeroDisclosure } from './disclosure';
import { zeroDivider } from './divider';
import { zeroDropdownMenu } from './dropdown-menu';
import { zeroErrorBanner } from './error-banner';
import { zeroErrorBoundary } from './error-boundary';
import { zeroErrorDialog } from './error-dialog';
import { zeroFileUpload } from './file-upload';
import { zeroFilter } from './filter';
import { zeroFilterBar } from './filter-bar';
import { zeroFlexLayout } from './flex-layout';
import { zeroFlipper } from './flipper';
import { zeroFlyout } from './flyout';
import { zeroGridLayout } from './grid-layout';
import { zeroGridLayoutItem } from './grid-layout-item';
import { zeroHorizontalScroll } from './horizontal-scroll';
import { zeroIcon } from './icon';
import { zeroListbox } from './listbox';
import { zeroListboxOption } from './listbox-option';
import { zeroMenu } from './menu';
import { zeroMenuItem } from './menu-item';
import { zeroModal } from './modal';
import { zeroMultiselect } from './multiselect';
import { zeroNotificationListener } from './notification-listener';
import { zeroNumberField } from './number-field';
import { zeroProgress } from './progress';
import { zeroProgressRing } from './progress-ring';
import { zeroRadio } from './radio';
import { zeroRadioGroup } from './radio-group';
import { zeroSegmentedControl } from './segmented-control';
import { zeroSegmentedItem } from './segmented-item';
import { zeroSelect } from './select';
import { zeroSkeleton } from './skeleton';
import { zeroSlider } from './slider';
import { zeroSliderLabel } from './slider-label';
import { zeroSnackbar } from './snackbar';
import { zeroStepper } from './stepper';
import { zeroStepperTab } from './stepper-tab';
import { zeroStepperTabPanel } from './stepper-tab-panel';
import { zeroSwitch } from './switch';
import { zeroTab } from './tab';
import { zeroTabPanel } from './tab-panel';
import { zeroTabs } from './tabs';
import { zeroTextArea } from './text-area';
import { zeroTextField } from './text-field';
import { zeroToast } from './toast';
import { zeroToolbar } from './toolbar';
import { zeroTooltip } from './tooltip';
import { zeroTreeItem } from './tree-item';
import { zeroTreeView } from './tree-view';
import { zeroUrlInput } from './url-input';
export const baseComponents = {
    zeroAccordion,
    zeroAccordionItem,
    zeroActionsMenu,
    zeroAnchor,
    zeroAnchoredRegion,
    zeroAvatar,
    zeroBadge,
    zeroBanner,
    zeroBreadcrumbItem,
    zeroBreadcrumb,
    zeroButton,
    zeroCalendar,
    zeroCard,
    zeroCheckbox,
    zeroCombobox,
    zeroConnectionIndicator,
    zeroDataGrid,
    zeroDesignSystemProvider,
    zeroDialog,
    zeroDatePicker,
    zeroDisclosure,
    zeroDivider,
    zeroDropdownMenu,
    zeroErrorBoundary,
    zeroNotificationListener,
    zeroErrorBanner,
    zeroErrorDialog,
    zeroFileUpload,
    zeroFilter,
    zeroFilterBar,
    zeroFlexLayout,
    zeroFlipper,
    zeroFlyout,
    zeroGridLayout,
    zeroGridLayoutItem,
    zeroHorizontalScroll,
    zeroIcon,
    zeroListbox,
    zeroListboxOption,
    zeroMenu,
    zeroMenuItem,
    zeroModal,
    zeroMultiselect,
    zeroNumberField,
    zeroProgress,
    zeroProgressRing,
    zeroRadio,
    zeroRadioGroup,
    zeroSegmentedControl,
    zeroSegmentedItem,
    zeroSelect,
    zeroSkeleton,
    zeroSlider,
    zeroSliderLabel,
    zeroSnackbar,
    zeroStepper,
    zeroStepperTab,
    zeroStepperTabPanel,
    zeroSwitch,
    zeroTab,
    zeroTabPanel,
    zeroTabs,
    zeroTextArea,
    zeroTextField,
    zeroToast,
    zeroToolbar,
    zeroTooltip,
    zeroTreeItem,
    zeroTreeView,
    zeroUrlInput,
    register(container, ...rest) {
        if (!container) {
            // preserve backward compatibility with code that loops through
            // the values of this object and calls them as funcs with no args
            return;
        }
        for (const key in this) {
            if (key === 'register') {
                continue;
            }
            this[key]().register(container, ...rest);
        }
    },
};
